import QueryString from 'qs';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Evaluation from '../../../components/cbt/speaking-test/Evaluation';
import Instruction from '../../../components/cbt/speaking-test/Instruction';
import useAxios from '../../../hooks/useAxios';
import {
  IGetSpeaking,
  ISpeakingResultBodyScale,
} from '../../../models/newSpeaking.model';
import { getSpeaking, postSpeakingResult } from '../../../api/newSpeaking.api';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import NewWindowLayout from '../../../components/layout/NewWindowLayout';
import useNotification from '../../../hooks/useNotification';
import { useTranslation } from 'react-i18next';

export enum ExamContents {
  Instruction,
  Evaluation,
};

const CbtSpeakingTestExam = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const placeTestCode = Number(query.placeTestCode);
  const speakingExamCode = Number(query.speakingExamCode);
  const memberName = String(query.memberName);
  const memberEngName = String(query.memberEngName);
  const gradeCode = String(query.gradeCode);
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetSpeaking>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [content, setContent] = useState<ExamContents>(ExamContents.Instruction);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    execute(getSpeaking(speakingExamCode));
  }, []);

  useEffect(() => {
    if (submitRes) {
      window.opener.postMessage({
        message: 'speaking-test-end',
        examTestCode: placeTestCode,
      }, '*');
      window.close();
    }
  }, [submitRes]);

  const onFinish = (answers: string[]) => {
    if ((res?.data?.papers?.length || 0) <= index + 1) {
      const scales: ISpeakingResultBodyScale[] = [];
      answers.forEach((value) => {
        const split = value.split('-');
        scales.push({
          evaluationNo: +split[0],
          orderSeq: +split[1],
        });
      });
      submitExecute(postSpeakingResult({
        examTestCode: placeTestCode,
        scales,
      }));
    } else {
      setIndex(index + 1);
    }
  };

  const renderContent = () => {
    if (res) {
      switch (content) {
        case ExamContents.Instruction:
          return (
            <Instruction
              data={res.data}
              onNext={() => {
                if (!res.data?.papers.length) {
                  return infoNotification(t('cbt.speakingTest.2'));
                }
                setContent(ExamContents.Evaluation);
              }}
              student={{ memberName, memberEngName, gradeCode }}
            />
          );
        case ExamContents.Evaluation:
          return (
            <Evaluation
              data={res.data}
              index={index}
              onFinish={onFinish}
              student={{ memberName, memberEngName, gradeCode }}
            />
          );
      }
    }
  };

  return (
    <NewWindowLayout
      title={`${res?.data?.eduStepCode === 'MD' ? 'Writing' : 'Speaking'} Test`}
    >
      {(isLoading || submitIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      {renderContent()}
    </NewWindowLayout>
  );
};

export default CbtSpeakingTestExam;